import { render, staticRenderFns } from "./StoveOff.vue?vue&type=template&id=4f6c4bd8&scoped=true"
import script from "./StoveOff.vue?vue&type=script&lang=js"
export * from "./StoveOff.vue?vue&type=script&lang=js"
import style0 from "./StoveOff.vue?vue&type=style&index=0&id=4f6c4bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c4bd8",
  null
  
)

export default component.exports